/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */
import Ajv from "ajv";
class StorageAdapter {
    constructor(config) {
        const ajv = new Ajv();
        this.storageMapping = config.storageMapping;
        this.storageLocation = config.storageLocation;
        ajv.addKeyword("x-storageLocation");
        this.validator = ajv.compile(config.schema);
    }
    async save(data) {
        if (!this.validator(data)) {
            throw new Error(`Invalid data provided: ${JSON.stringify(this.validator.errors)}`);
        }
        const storageObjects = this.decomposeObject(data);
        // Prepare data for each storage location without saving it yet
        const preparePromises = Object.keys(storageObjects).map(async (location) => {
            var _a, _b;
            if (storageObjects[location]) {
                await ((_b = (_a = this.storageLocation[location]).set) === null || _b === void 0 ? void 0 : _b.call(_a, location, JSON.stringify(storageObjects[location])));
            }
        });
        // Wait for all data to be prepared
        await Promise.all(preparePromises);
        // Save data for each storage location in a single call
        const savePromises = Object.keys(this.storageLocation).map(async (location) => {
            var _a, _b;
            await ((_b = (_a = this.storageLocation[location]).save) === null || _b === void 0 ? void 0 : _b.call(_a));
        });
        // Wait for all data to be saved
        await Promise.all(savePromises);
    }
    async get() {
        let resultObject = {};
        const promises = Object.keys(this.storageLocation).map(async (location) => {
            var _a, _b;
            if (this.storageLocation[location]) {
                const partialData = await ((_b = (_a = this.storageLocation[location]).get) === null || _b === void 0 ? void 0 : _b.call(_a, location));
                if (partialData) {
                    resultObject = Object.assign(Object.assign({}, resultObject), JSON.parse(partialData));
                }
            }
        });
        await Promise.all(promises);
        return resultObject;
    }
    static resolveKeyPath(obj, path) {
        return path
            .split(".")
            .reduce((prev, curr) => (prev ? prev[curr] : null), obj);
    }
    static assignKeyPath(obj, path, value) {
        const keys = path.split(".");
        keys.reduce((prev, curr, idx) => {
            if (idx === keys.length - 1) {
                prev[curr] = value;
            }
            else {
                prev[curr] = prev[curr] || {};
            }
            return prev[curr];
        }, obj);
    }
    decomposeObject(dataObject) {
        const storageObjects = {};
        Object.values(this.storageMapping).forEach((location) => {
            storageObjects[location] = {};
        });
        const { resolveKeyPath, assignKeyPath } = StorageAdapter;
        Object.keys(this.storageMapping).forEach((key) => {
            const location = this.storageMapping[key];
            const value = resolveKeyPath(dataObject, key);
            if (value !== null && value !== undefined) {
                assignKeyPath(storageObjects[location], key, value);
            }
        });
        return storageObjects;
    }
}
export default StorageAdapter;
